import { Component, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { intervalToDuration } from 'date-fns';

interface SystemConfig {
    data: any;
    message: boolean;
    status: number;
    // created_at: string;
    // is_maintenance_on: boolean;
    // maintenance_end_time: string;
    // updated_at: string;
    // __v: number;
    // _id: string;
}

@Component({
    selector: 'app-maintenance',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    template: `
        <div class="d-flex align-item-center justify-content-center h-100vh">
            <div class="maintenance-page">
                <div class="p-3 my-4 d-inline-block w-100 justify-content-center text-center">
                    <a routerLink="" aria-label="ixfi-logo">
                        <img [src]="CDN_URL + 'new-header/logo.svg'" alt="" width="200" alt="ixfi Logo" />
                    </a>
                    <h1 class="pt-3">{{ 'MAINTENANCE.IXFI_RESEARCH_IS_UPGRADING' | translate }}</h1>
                    <div class="d-flex affiliate-counter">
                        <div class="affiliate-hours">
                            <h3 id="countdownHours">{{ duration?.hours }}</h3>
                            <span>{{ 'MAINTENANCE.HOURS' | translate }}</span>
                        </div>
                        <div class="affiliate-minutes">
                            <h3 id="countdownMinutes">{{ duration?.minutes }}</h3>
                            <span>{{ 'MAINTENANCE.MINUTES' | translate }}</span>
                        </div>
                        <div class="affiliate-seconds">
                            <h3 id="countdownSeconds">{{ duration?.seconds }}</h3>
                            <span>{{ 'MAINTENANCE.SECONDS' | translate }}</span>
                        </div>
                    </div>
                    <p>{{ 'MAINTENANCE.PLEASE_WAIT_FOR_THE_UPGRADE' | translate }}</p>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
    CDN_URL = environment.CDN_URL;

    isMaintenanceModeOn = false;
    data: any;
    retryAfter!: Date;
    maintenanceTime;
    duration: Duration | any = { hours: undefined, minutes: undefined, seconds: undefined };
     intervalCallback: number | undefined;
    durationCallBack!: ReturnType<typeof setInterval>;

    private router = inject(Router);
    private http = inject(HttpClient);
    private platformId = inject(PLATFORM_ID);

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.checkServerStatus();

            /* Get `Retry-After` value from Local Storage */
            const dateFromStorage: string | null = localStorage.getItem('Retry-After');

            /**
             * If dateFromStorage is a valid truth-ify value, then assign it to `retryAfter` Date variable
             * Else, assign the current date
             */
            if (dateFromStorage && dateFromStorage.length > 0) this.retryAfter = new Date(dateFromStorage);
            else this.retryAfter = new Date();

            /**
             * Calculate Duration between now and the `retryAfter` date
             * Update this value every second by running it in setInterval
             */
            this.durationCallBack = setInterval(() => {
                this.duration = intervalToDuration({ start: new Date(), end: this.retryAfter });
            }, 1000);

            /**
             * If Maintenance mode is on, send a HTTP request every 3 seconds
             * to check the status of the system
             */
                if (this.isMaintenanceModeOn) {
                this.intervalCallback = setInterval(() => {
                    this.checkServerStatus();
                }, 3000) as any; 
            } else {
                if (this.intervalCallback !== undefined) {
                    clearInterval(this.intervalCallback);
                }
            }
            }
        }
    
    /* HTTP call to check server status */
    private checkServerStatus() {
        // this.http.get<{ status: number; message: string; data: { system_config: SystemConfig } }>(
        //     `${environment.COIN_INFO_API}health/get-system-config`
        // );
        this.http
            .get<{ status: number; message: string; data: { system_config: SystemConfig } }>(
                `${environment.IXFI_API}misc/get-system-config?server_name=ALL`
            )
            .subscribe({
                next: response => {
                    /* Check If maintenance mode is on */

                    // this.isMaintenanceModeOn = response.data.system_config.is_maintenance_on;
                    // if (response.status === 200 && this.isMaintenanceModeOn) {
                    //     localStorage.setItem('Retry-After', response.data.system_config.maintenance_end_time);
                    //     /* Update the retryAfter Date */
                    //     this.retryAfter = new Date(response.data.system_config.maintenance_end_time);
                    //     /* Update the Duration Timer */
                    //     this.duration = intervalToDuration({ start: new Date(), end: this.retryAfter });
                    // } else {
                    //     localStorage.removeItem('Retry-After');
                    //     this.router.navigate(['/']);
                    //     clearInterval(this.durationCallBack);
                    // }

                    this.data = response.data;
                    this.isMaintenanceModeOn = this.data.is_maintenance_on;
                    if (response.status === 200 && this.isMaintenanceModeOn) {
                        if (this.data.is_global_maintenance_on) {
                            if (this.data.global && this.data.global.is_maintenance_on) {
                                this.maintenanceTime = this.data.global['maintenance_end_time'];
                            }
                        } else {
                            if (this.data.coin_info && this.data.coin_info.is_maintenance_on) {
                                this.maintenanceTime = this.data.coin_info['maintenance_end_time'];
                            } else if (this.data.web && this.data.web.is_maintenance_on) {
                                this.maintenanceTime = this.data.web['maintenance_end_time'];
                            } else if (this.data.web.research && this.data.web.research.is_maintenance_on) {
                                this.maintenanceTime = this.data.web.research['maintenance_end_time'];
                            } else {
                                this.maintenanceTime = this.data['maintenance_end_time'];
                            }
                        }

                        localStorage.setItem('Retry-After', JSON.stringify(this.maintenanceTime));
                        /* Update the retryAfter Date */
                        this.retryAfter = new Date(this.maintenanceTime);
                        /* Update the Duration Timer */
                        this.duration = intervalToDuration({ start: new Date(), end: this.retryAfter });
                    } else {
                        localStorage.removeItem('Retry-After');
                        this.router.navigate(['/']);
                        clearInterval(this.durationCallBack);
                    }
                },
                error: _ => this.router.navigate(['/'])
            });
    }
}
